import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

// project imports
import type { RootState, AppDispatch } from 'models/store';

// ==============================|| HOOKS ||============================== //

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
